import { ChipProps } from '@aibees/shared/components';
import { useMemo } from 'react';
import {
  useLabelColors,
  useListColor,
} from '../components/action-bulk-select-color-label/config';
import { Label, LabelType } from '../types/label';

export const useMapColorToChipColor = (label: Label): ChipProps['color'] => {
  const listColor = useListColor(label.grouping);
  const colors = useLabelColors();
  const isLabel = useMemo(() => label.type === LabelType.LABEL, [label.type]);

  const colorMap: Record<string, ChipProps['color']> = {
    [colors.primary]: 'primary',
    [colors.error]: 'error',
    [colors.warning]: 'warning',
    [colors.success]: 'success',
    [colors.grey]: 'default',
  };
  return isLabel ? colorMap[label.color] : colorMap[listColor];
};
